export default {
	title: "Наши контакты в Telegram",
	chat: {
		title: "Бизнес, деньги, общепит",
		about: "Чат для рестораторов и экспертов",
		link: "https://t.me/resto_business",
		bubble: "./assets/chat-bubble.png",
	},
	bot: {
		title: "Quick Resto Бот",
		about: "Техподдержка",
		link: "https://t.me/QuickResto_bot",
		bubble: "./assets/bot-bubble.png",
	},
	community: {
		title: "Quick Resto Community",
		about: "Сообщество пользователей",
		link: "https://t.me/QuickRestoCommunity",
		bubble: "./assets/community-bubble.png",
	},
}
